import { Company } from '@/interfaces/vuex/company';
import { DepartmentsState } from '@/interfaces/vuex/department';
import { User } from '@/interfaces/vuex/user';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';
import { AppNotification, MainState } from './state';
import { Locale } from '@/interfaces/api/general/language';

export const mutations = {
  setInitialized(state: MainState, payload: boolean) {
    state.initialized = payload;
  },
  setForceEnroll2Fa(state: MainState, payload: boolean) {
    state.forceEnroll2Fa = payload;
  },
  setCompany(state: MainState, payload: Company | null) {
    state.company = payload;
  },
  setSwitchableCompanies(state: MainState, payload: Company[]) {
    state.switchableCompanies = payload;
  },
  setDepartments(state: MainState, payload: DepartmentsState | null) {
    state.departments = payload;
  },
  setCurrentUserProfile(state: MainState, payload: User | null) {
    state.userProfile = payload;
  },
  setDashboardMiniDrawer(state: MainState, payload: boolean) {
    state.dashboardMiniDrawer = payload;
  },
  setDashboardShowDrawer(state: MainState, payload: boolean) {
    state.dashboardShowDrawer = payload;
  },
  addNotification(state: MainState, payload: AppNotification) {
    state.notifications.splice(0);
    state.notifications.push(payload);
  },
  removeNotification(state: MainState, payload: AppNotification) {
    state.notifications = state.notifications.filter(
      (notification) => notification !== payload
    );
  },
  setUserLocale(state: MainState, payload: Locale) {
    // Update the userProfile if it exists (for logged-in users)
    if (state.userProfile) {
      state.userProfile.locale = payload;
    } else {
      // update nonLoggedInUserLocale in the store to trigger the watcher in main.ts
      // This is critical for non-logged-in users where userProfile.locale might not be used
      state.nonLoggedInUserLocale = payload;
    }
  },
  setFeatureFlags(state: MainState, payload: Record<string, boolean>) {
    state.featureFlags = payload;
  },
  setPollingIntervalOfFeatureFlags(
    state: MainState,
    timeoutFunction: NodeJS.Timeout | null
  ) {
    state.pollingIntervalOfFeatureFlags = timeoutFunction;
  },
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const { commit } = getStoreAccessors<MainState | any, State>('');

export const commitSetDashboardMiniDrawer = commit(
  mutations.setDashboardMiniDrawer
);
export const commitSetDashboardShowDrawer = commit(
  mutations.setDashboardShowDrawer
);
export const commitSetInitialized = commit(mutations.setInitialized);
export const commitSetForceEnroll2Fa = commit(mutations.setForceEnroll2Fa);
export const commitSetCompany = commit(mutations.setCompany);
export const commitSetSwitchableCompanies = commit(
  mutations.setSwitchableCompanies
);
export const commitSetDepartments = commit(mutations.setDepartments);
export const commitSetCurrentUser = commit(mutations.setCurrentUserProfile);
export const commitAddNotification = commit(mutations.addNotification);
export const commitRemoveNotification = commit(mutations.removeNotification);
export const commitSetUserLocale = commit(mutations.setUserLocale);
export const commitSetFeatureFlags = commit(mutations.setFeatureFlags);
export const commitSetPollingInterval = commit(
  mutations.setPollingIntervalOfFeatureFlags
);
